//export type Icon =  'Bell'| 'Bolt' | 'Caret' | 'ArrowRight' | 'Home';
export const SEP: string = '/';

export function isHomePage(pHref: string): boolean {
    return pHref.indexOf('Dashboard') != -1;
}

export function IsSubMenu(itemMenu: ItemMenu): boolean {
    return itemMenu.menu.length > 0 && !itemMenu.forceAsNotSubmenu;
}

export interface SmallItemMenu {
    urlPage: string;
    icon: string;
}

export interface ItemMenu {
    name: string;
    urlPage: string;
    isExternalUrl: boolean;
    icon: string;
    tooltip: string;
    learnMore?: string;
    helpKeywords: string[];
    regex?: string;
    menu: ItemMenu[];
    forceAsNotSubmenu?: boolean;
    isNew: boolean;
    isAI: boolean;
    permissions: string[];
}

export function _findByPathSmall(
    listItemMenu: ItemMenu[],
    arrayMenuPath: string[],
    currIndex: number = 0,
    itemMenu: ItemMenu = {} as ItemMenu,
    smallItemMenu: SmallItemMenu[] = []
): SmallItemMenu[] {
    if (currIndex < arrayMenuPath.length) {
        if (currIndex == 0) {
            itemMenu = listItemMenu[parseInt(arrayMenuPath[currIndex]) - 1];
        } else {
            itemMenu = itemMenu.menu[parseInt(arrayMenuPath[currIndex]) - 1];
        }
        smallItemMenu.push({ urlPage: itemMenu.urlPage, icon: itemMenu.icon });

        currIndex++;
        return _findByPathSmall(listItemMenu, arrayMenuPath, currIndex, itemMenu, smallItemMenu);
    } else {
        return smallItemMenu;
    }
}

export const isExist = (arrayItemMenu: ItemMenu, curMenu: string): boolean => {
    if (curMenu === '') {
        return true;
    } else {
        let arrayMenuPath = curMenu.split(SEP);
        const finalItem = _isExist(arrayItemMenu.menu, arrayMenuPath);
        return finalItem;
    }
};

const _isExist = (listItemMenu: ItemMenu[], arrayMenuPath: string[], currIndex: number = 0, itemMenu: ItemMenu = {} as ItemMenu): boolean => {
    if (currIndex < arrayMenuPath.length) {
        if (currIndex == 0) {
            itemMenu = listItemMenu[parseInt(arrayMenuPath[currIndex]) - 1];
        } else {
            itemMenu = itemMenu.menu[parseInt(arrayMenuPath[currIndex]) - 1];
        }

        if (itemMenu === undefined) {
            return false;
        }

        currIndex++;
        return _isExist(listItemMenu, arrayMenuPath, currIndex, itemMenu);
    } else {
        return true;
    }
};
